import React from 'react';
import PencilIconSvg from './PencilIcon.svg';

const PencilIcon = (props) => (
    <img src={PencilIconSvg} alt="User Layout" {...props} />
);

export default PencilIcon;
